module.exports = new __parcel__URL__("WhiteboardsPaywallV2.5dd554e3.svg").toString();